import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { addCommas } from 'src/app/utils/addCommas';

@Component({
  selector: 'app-graf-skladisce-letos-lani-pie',
  templateUrl: './graf-skladisce-letos-lani-pie.component.html',
  styleUrls: ['./graf-skladisce-letos-lani-pie.component.css']
})
export class GrafSkladisceLetosLaniPieComponent implements OnInit, OnChanges {

  @Input() compareCalc;
  @Input() sumDatesVarCmp;
  @Input() sumDatesVar;
  public pieChartOptions: ChartOptions = {
    responsive: true,

    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          return '';
        },
      },
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            // context.parsed.y will give you the value of the data point
            let label = context.dataset.label || '';
            let value = context.parsed.y;
            if (value >= 1000) {
              return label + ': ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              return label + ': ' + value.toString();
            }
          }
        }
      },
    },


  };
  public pieChartLabels: string[] = ['Prodaja letos', 'Prodaja lani'];
  public pieChartData: number[];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;

  public pieChartColors: Array<any> = [{
    backgroundColor: ['rgb(152,251,152)', 'rgba(255,0,0,0.3)']
  }];


  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    this.ngOnInit();
  }

  ngOnInit() {
    console.log(this.compareCalc);
    console.log(this.sumDatesVarCmp + ' ' + Number(addCommas(this.sumDatesVarCmp)));
    console.log(this.sumDatesVar + " " + Number(addCommas(this.sumDatesVar)));
    this.pieChartData = [(this.sumDatesVar), (this.sumDatesVarCmp)];
  }

}
